import {CategoryListSkeleton, mobileOnly} from '@aboutyou/ui-components';
import React from 'react';
import styled, {css} from 'styled-components';

export const CategorySliderWrapper = styled.div`
  box-sizing: border-box;
  width: 100vw;
  padding: 0.5rem 0.75rem;

  ${mobileOnly(css`
    padding: 0.5rem 1rem;
  `)}
`;

export const CategorySliderLoading = () => {
  return (
    <CategorySliderWrapper data-testid="categorySlider">
      <CategoryListSkeleton />
    </CategorySliderWrapper>
  );
};
